import React from 'react';
import { IconButton, Typography, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const CustomPagination = ({ count, page, pageSize, onPageChange, onPageSizeChange }) => {
  const handleFirstPage = () => {
    onPageChange(0);
  };

  const handleLastPage = () => {
    const lastPage = Math.max(0, Math.ceil(count / pageSize) - 1);
    onPageChange(lastPage);
  };

  const handleBackButtonClick = () => {
    onPageChange(page - 1);
  };

  const handleNextButtonClick = () => {
    onPageChange(page + 1);
  };

  const handlePageSizeChange = (event) => {
    onPageSizeChange(parseInt(event.target.value, 10)); // Change page size
    onPageChange(0); // Reset to the first page
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <IconButton onClick={handleFirstPage} disabled={page === 0}>
        <FirstPageIcon />
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0}>
        <ChevronLeftIcon />
      </IconButton>
      <Typography style={{ margin: '0 16px' }}>
        {page + 1} of {Math.ceil(count / pageSize)}
      </Typography>
      <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / pageSize) - 1}>
        <ChevronRightIcon />
      </IconButton>
      <IconButton onClick={handleLastPage} disabled={page >= Math.ceil(count / pageSize) - 1}>
        <LastPageIcon />
      </IconButton>
      <FormControl variant="outlined" size="small" style={{ marginLeft: '16px', width: '100px' }}>
        <InputLabel>Rows per page</InputLabel>
        <Select
          label="Rows per page"
          value={pageSize}
          onChange={handlePageSizeChange}
        >
          {[20, 50, 100].map((size) => (
            <MenuItem key={size} value={size}>
              {size}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default CustomPagination;
